import { render, staticRenderFns } from "./ApplicationstatusPage.vue?vue&type=template&id=010408b6&scoped=true&"
import script from "./ApplicationstatusPage.vue?vue&type=script&lang=js&"
export * from "./ApplicationstatusPage.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationstatusPage.vue?vue&type=style&index=0&id=010408b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010408b6",
  null
  
)

export default component.exports